var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.limpiar_devolucion}},[_c('i',{staticClass:"icon-cancel"}),_vm._v(" Cancelar ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }